import { render, staticRenderFns } from "./SubscriptionResult.vue?vue&type=template&id=3a231668&scoped=true&"
import script from "./SubscriptionResult.vue?vue&type=script&lang=js&"
export * from "./SubscriptionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a231668",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/subscription/SubscriptionResult.vue
// module id = 1408
// module chunks = 0